import {gql} from "@apollo/client";

export const MOLLIE_CONNECTION_STATUS = gql`
    query MollieConnectionStatus {
        mollieConnectionStatus {
            isConnected
            canReceivePayments
            canReceiveSettlements
            connectedAt
            mollieOrganizationId
            mollieProfileId
            capabilitiesHint
            isTestMode
            needsReconnect
            onboardingStatus
            dashboardUrl
        }
    }
`;

export const MOLLIE_AVAILABLE_METHODS = gql`
    query MollieAvailableMethods {
        mollieAvailableMethods {
            id
            description
            imageUrl
            isEnabled
            isAvailableInProfile
            profileStatus
        }
    }
`;

export const MOLLIE_PAYMENT_STATUS = gql`
    query MolliePaymentStatus($scheduledPaymentId: ID!) {
        molliePaymentStatus(scheduledPaymentId: $scheduledPaymentId) {
            molliePaymentId
            status
            paidAt
            amount
        }
    }
`;

export const MOLLIE_GET_CONNECT_URL = gql`
    mutation MollieGetConnectUrl {
        mollieGetConnectUrl
    }
`;

export const MOLLIE_DISCONNECT = gql`
    mutation MollieDisconnect {
        mollieDisconnect
    }
`;

// Mollie Connect for Platforms — erstellt einen Client Link (Merchant-Onboarding)
// und liefert die fertige Onboarding-URL zurück (§D Schritt 4/5). Admin + Superuser (Self-Service-Onboarding).
export const MOLLIE_CREATE_CLIENT_LINK = gql`
    mutation MollieCreateClientLink($input: MollieCreateClientLinkInput!, $returnTo: String) {
        mollieCreateClientLink(input: $input, returnTo: $returnTo) {
            clientLinkUrl
            clientLinkId
        }
    }
`;

export const CREATE_MOLLIE_PAYMENT = gql`
    mutation CreateMolliePayment($scheduledPaymentId: ID!, $method: String!) {
        createMolliePayment(scheduledPaymentId: $scheduledPaymentId, method: $method) {
            molliePaymentId
            checkoutUrl
            status
        }
    }
`;

export const RETRY_MOLLIE_PAYMENT = gql`
    mutation RetryMolliePayment($scheduledPaymentId: ID!) {
        retryMolliePayment(scheduledPaymentId: $scheduledPaymentId) {
            molliePaymentId
            checkoutUrl
            status
        }
    }
`;

export const UPDATE_MOLLIE_ENABLED_METHODS = gql`
    mutation UpdateMollieEnabledMethods($methodIds: [String!]!) {
        updateMollieEnabledMethods(methodIds: $methodIds) {
            id
            description
            imageUrl
            isEnabled
            isAvailableInProfile
            profileStatus
        }
    }
`;

export const MOLLIE_ALL_METHODS_FOR_WHITELIST = gql`
    query MollieAllMethodsForWhitelist {
        mollieAllMethodsForWhitelist {
            id
            description
            imageUrl
            isEnabled
            isAvailableInProfile
            profileStatus
        }
    }
`;

export const UPDATE_ALLOWED_MOLLIE_METHODS = gql`
    mutation UpdateAllowedMollieMethods($methods: [String!]!) {
        updateAllowedMollieMethods(methods: $methods) {
            id
            allowedMollieMethods
        }
    }
`;

// v2.2 Block 3.2 — Impact-Zahlen für den Superuser-Confirm-Modal
// vor dem Abschalten von Subscription.featureMollie.
export const MOLLIE_DOWNGRADE_IMPACT = gql`
    query MollieDowngradeImpact($koOrganizationId: ID!) {
        mollieDowngradeImpact(koOrganizationId: $koOrganizationId) {
            openMolliePayments
            activePaymentLinks
            affectedBookers
        }
    }
`;
